<template>
    <section :style="`position: relative; z-index: 1;background-image: url(${ type === 1 ? bg : bg2 })`">
      <!-- <template v-if="type === 1">
        <img class="is_block" src="https://www.stanford.edu/wp-content/uploads/2017/03/hoover-background-lg.jpg" />
      </template>
      <template v-else-if="type === 2">
        <img class="is_block" src="https://www.stanford.edu/wp-content/uploads/2022/04/web_footer_2-2048x753.jpg" />
      </template> -->
    </section>
</template>

<script>
export default {
    props: {
        type: {
            type: Number,
            require: true
        }
    },
    data() {
        return {
            bg: require('@/assets/temp/poster.png'),
            bg2: require('@/assets/temp/poster2.png')
        }
    }
}
</script>

<style lang="scss" scoped>
section {
    min-width: 1500px;
    width: 100%;
    // height: 300px;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center bottom;
}
</style>
